var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"premium-buy-page",attrs:{"data-test":"page-premium"}},[_c('div',{staticClass:"m-t-2"},[_c('add-payment-info',{attrs:{"heading":"Billing Information"},on:{"success":_vm.successAction}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8584e0","hasScoped":false,"transformToRequire":{"svg-component":"src","video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--1-1!./app/src/pages/onboarding/AdyenBuyPremium.vue
// module id = null
// module chunks = 